import mapFunction from './mapResources';

export default mapFunction('buildings_with_performances', {
    isFetching: false,
    items: []
});